import React from 'react';
import {connect} from 'react-redux';
import { withLastLocation } from "react-router-last-location";
import Dialog from '@material-ui/core/Dialog';

import { trackEvent } from '../../../helpers/analyticsHelper';

import FooterMain from '../../standalone/common/Footer/FooterMain';
import RecommendationsTop5 from './RecommendationsTop5/RecommendationsTop5';
import RecommendationsTips from './RecommendationsTips/RecommendationsTips';
import RecommendationsPrograms from './RecommendationsPrograms/RecommendationsPrograms';
import RecommendationDetailsModal from './RecommendationsTips/RecommendationDetailsModal';

import { fetchTop5Reco, fetchTipsToSaveEnergy, onViewRecos, onRecoLike, onRecoUnlike, fetchRecoPrograms } from '../../../dataFetchers/recoDataFetcher';
import { toggleFilterDropdown, toggleRecoDropdownCheckbox, showRecoLoader, showMoreRecos, onUnselectAllRecosDropdown, setDropdownValues, setUpdatingLikes, setAllowedAppliances } from '../../../actions/recommendationsActions';
import {queryRecoCardLoaded} from '../../../actions/recoDetailsActions';

import { getBECompatibleLocale, setPageTitle } from '../../../helpers/helper';
import{ Configuration } from '../../../configs/Configuration';
import { WHOLE_HOME, LIKE, FUEL_TYPE, SELECT_ALL, PAGE_EVENT_NAMES, RECO_TYPE, ARROWS, RECO_RESPONSE } from '../../../constants/common';

class RecommendationsPageMain extends React.Component {
    unViewedRecos = [];
    state = {
        open: false,
        activeRecoId: null
    };
    configColors = Configuration.getColors().colors;

    componentDidMount() {
        if(!this.props.recommendationsData.allowedAppliances.length){
            this.props.setAllowedAppliances(this.props.configs.data["recommendationsDropdownAppliancesList"].split(','));
        }
        let selectedAppliances = this.props.recommendationsData.selectedAppliances;
        let wholeHomeSelected = false;
        if(!selectedAppliances.length){
            if(this.props.queryParams && this.props.queryParams.appId){
                selectedAppliances = this.props.queryParams.appId;
                this.props.setDropdownValues(selectedAppliances)
            } else {
                selectedAppliances = this.props.configs.data["recommendationsDropdownAppliancesList"];
                this.props.setDropdownValues(selectedAppliances.split(','));
                wholeHomeSelected = true;
            }
        }

        setPageTitle("RECOMMENDATIONS_PAGE.TITLE", this.props.translations.data, this.props.configs.data);
        this.props.recommendationsData.recoTop5Data === null && this.props.fetchTop5Reco(this.props.userIdentityDetails.userId, getBECompatibleLocale(this.props.configs.data));
        this.props.recommendationsData.recoTipsToSaveEnergy === null && this.props.fetchTipsToSaveEnergy(this.props.userIdentityDetails.userId, this.props.configs.data['fuelType'], selectedAppliances, getBECompatibleLocale(this.props.configs.data), wholeHomeSelected);
        this.props.recommendationsData.recoPrograms === null && this.props.fetchRecoPrograms(this.props.userIdentityDetails.userId, this.props.configs.data['fuelType'], getBECompatibleLocale(this.props.configs.data));

        //call analytics function to save viewed event
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
            viewed: true
        }, this.props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.recommendationsData.recoTop5Data !== prevProps.recommendationsData.recoTop5Data && !prevProps.recommendationsData.recoTop5Data) {
            //If no recos are present in carousel, send data to mixpanel or else mark 1st item of carousel as viewed
            if (this.props.recommendationsData.recoTop5Data.viewedRecommendationWrapperList.length === 0 && this.props.recommendationsData.recoTop5Data.unviewedRecommendationWrapperList.length === 0) {
                trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
                    noreco: "true",
                    carousel: true
                });
            }else {
                this.props.recommendationsData.recoTop5Data.unviewedRecommendationWrapperList.map(item => {
                    item && this.unViewedRecos.push(item.recommendationsMetaData.recommendationId);
                    return item;
                });
                this.onViewRecos(0);
            }
        }
        if(this.props.queryParams && this.props.queryParams.recoId && this.props.configs.data['DASHBOARD.RECOMMENDATION_DETAILS_ENABLED'] === "true" && !this.props.recoDetailsData.queryCardLoaded){
            this.props.queryRecoCardLoaded();
            this.handleModal(this.props.queryParams.recoId);
        }

        //Track no reco tips found in grid
        if (prevProps.recommendationsData.recoTipsToSaveEnergy !== this.props.recommendationsData.recoTipsToSaveEnergy && this.props.recommendationsData.recoTipsToSaveEnergy.length === 0) {
            trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
                noreco: "true",
                grid: true
            });
        }
    }

    //reco like or unlike
    handleRecoLikeUnlike(index, event){
        event.stopPropagation();
        let recommendation = this.props.recommendationsData.recoTipsToSaveEnergy[index];
        if(recommendation.updatingLikes){
            return;
        }

        this.props.setUpdatingLikes(index);
        let recommendationsMetaData = recommendation.recommendationsMetaData;
        switch(recommendation.recommendationFeedback.response){
            case RECO_RESPONSE.UNLIKE : {
                //Trigger LIKE in this case 
                let obj = {
                    "timestamp": new Date().getTime(),
                    "response": RECO_RESPONSE.LIKE,
                    "recommendationID": recommendationsMetaData.recommendationId,
                    "userID": this.props.userIdentityDetails.userId,
                    "homeID": 1,
                    "pilotID": this.props.userObject.details.pilotId
                };
                this.props.onRecoLike(obj, index);

                //Track likes on recommnedations
                trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
                    clicked: RECO_RESPONSE.LIKE,
                    recoID: recommendationsMetaData.recommendationId,
                    recoLink: recommendationsMetaData.link,
                    primaryRecoID: recommendationsMetaData.primaryRecommendationId,
                    callToAction: recommendationsMetaData.callToAction,
                });
            }
            break;
            case RECO_RESPONSE.LIKE :{
                //Trigger UNLIKE in this case
                this.props.onRecoUnlike(this.props.userIdentityDetails.userId, recommendationsMetaData.recommendationId, index);
                trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
                    clicked: RECO_RESPONSE.DISLIKE,
                    recoID: recommendationsMetaData.recommendationId,
                    recoLink: recommendationsMetaData.link,
                    primaryRecoID: recommendationsMetaData.primaryRecommendationId,
                    callToAction: recommendationsMetaData.callToAction,
                });
            }
            break;
            default:
            break;
        }
    }

    //close and open the filter dropdown
    onToggleFilterDropdown(e) {
        this.props.toggleFilterDropdown({
            recoFilterDropdownEl: e ? e.currentTarget: e
        });
    }

    //select and unselect checkboxes for appliances in dropdown filter
    onApplianceCategoryCheckboxSelect(e) {
        this.props.toggleRecoDropdownCheckbox(e.target.value);
    }

    //on clicking apply filters, create a comma separated string from the categories id to call the api
    onApplyingFilters() {
        this.props.showRecoLoader();
        let allSelected = this.props.recommendationsData.recoDropdownCheckboxAppliances[SELECT_ALL];
        let wholeHomeSelected = false;
        let applianceIdStrings = [];

        let dropdownRecoList = this.props.configs.data["recommendationsDropdownAppliancesList"];

        //map all the appliances from their names to their ids
        let keys = Object.keys(this.props.recommendationsData.recoDropdownCheckboxAppliances);

        //If select all is checked, call with all the appliance ids from the configs to fetch all the data
        if (allSelected) {
            this.props.fetchTipsToSaveEnergy(this.props.userIdentityDetails.userId, this.props.configs.data['fuelType'], dropdownRecoList, getBECompatibleLocale(this.props.configs.data), true);
        }else {
            for (let i = 1; i < keys.length; i++) {
                let applianceSelected = this.props.recommendationsData.recoDropdownCheckboxAppliances[keys[i]];
                if (applianceSelected) {
                    if (keys[i] === WHOLE_HOME) {
                        wholeHomeSelected = true;
                    }else {
                        applianceIdStrings.push(keys[i]);
                    }
                }
            }
            //convert from array to comma seperated string and call api
            applianceIdStrings = applianceIdStrings.join(",");
            //If none of the appliances are selected, don't call api and show no recos found message or else call api to fetch recos
            if (applianceIdStrings || wholeHomeSelected) {
                this.props.fetchTipsToSaveEnergy(this.props.userIdentityDetails.userId, this.props.configs.data['fuelType'], applianceIdStrings, getBECompatibleLocale(this.props.configs.data), wholeHomeSelected);
            }else {
                this.props.onUnselectAllRecosDropdown();
            }
        }

        //Track change of filters
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
            filter: true,
            filterItems: allSelected ? dropdownRecoList : dropdownRecoList.split(",").filter(item => applianceIdStrings.includes(item)).join(",")
        })

        this.onToggleFilterDropdown();
    }

    showMoreRecos() {
        this.props.showMoreRecos();
        //Track change of filters
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
            scroll: "true"
        })
    }

    onViewRecos(index) {
        if (this.props.recommendationsData.recoTop5Data.unviewedRecommendationWrapperList && this.props.recommendationsData.recoTop5Data.unviewedRecommendationWrapperList.length > 0) {
            if (index < this.props.recommendationsData.recoTop5Data.unviewedRecommendationWrapperList.length && this.unViewedRecos[index]) {
                this.props.onViewRecos(this.props.userIdentityDetails.userId, this.unViewedRecos[index]);
                this.unViewedRecos[index] = null;
            }
        }

        //Track center item of carousal
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
            viewed: "recommendation",
            recoId: [...this.props.recommendationsData.recoTop5Data.unviewedRecommendationWrapperList, ...this.props.recommendationsData.recoTop5Data.viewedRecommendationWrapperList][index].recommendationId,
            carousel : "true"
        })
    }

    onHoverRecos(id, type) {
        //Track hover event on tips
        let params = {
            hover: "recommendation",
            recoId: id
        };
        if (type === RECO_TYPE.CAROUSEL) {
            params.carousel = true;
        }else if(type === RECO_TYPE.PROGRAM){
            params.program = true;
        } else {
            params.grid = true;
        }

        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, params)
    }

    onChangeSlider(prevIndex, newIndex) {
        //On change of slides, trigger this function to determine which arrow was clicked
        let arrowClicked = ARROWS.LEFT;
        if (prevIndex + 1 === newIndex || (newIndex === 0 && prevIndex - 1 !== newIndex )) {
            arrowClicked = ARROWS.RIGHT;
        }
        trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
            carouselClicked: arrowClicked
        })
    }

    handleModal(recoId) {
        let isModalOpen = this.state.open;
        this.setState({
            open: !isModalOpen,
            activeRecoId: recoId || null
        });

        //Track reco open/close event
            trackEvent(this.props.userIdentityDetails.userId, PAGE_EVENT_NAMES.RECOMMENDATIONS, {
                recoID : recoId,
                open : !isModalOpen,
                close : isModalOpen
            }) 
    }

    render() {
        const recoInsightsEnabled = this.props.configs.data["DASHBOARD.RECO_INSIGHTS_ENABLED"] === "true";
        const insightBulbImage = this.props.configs.data["DASHBOARD.RECOMMENDATIONS.INSIGHTS_BULB"];
        return(
            <>
            <div className="recommendations-outer-container reco-page-main">
                <RecommendationsTop5 recommendationsData={this.props.recommendationsData} onViewRecos={(index) => this.onViewRecos(index)} translations={this.props.translations.data}
                    onHoverRecos={(id, type) => this.onHoverRecos(id, type)} onChangeSlider={(prevIndex, index) => this.onChangeSlider(prevIndex, index)}
                    configs={this.props.configs.data} handleModal={(recoId) => this.handleModal(recoId)} recoInsightsEnabled={recoInsightsEnabled} insightBulbImage={insightBulbImage}/>

                {this.props.recommendationsData.recoPrograms && 
                <RecommendationsPrograms userIdentityDetails={this.props.userIdentityDetails} recoPrograms={this.props.recommendationsData.recoPrograms} translations={this.props.translations.data} 
                recoInsightsEnabled={recoInsightsEnabled} insightBulbImage={insightBulbImage} configs={this.props.configs.data} onHoverRecos={(id, type) => this.onHoverRecos(id, type)}/>}

                <RecommendationsTips recommendationsData={this.props.recommendationsData} onHoverRecos={(id, type) => this.onHoverRecos(id, type)}
                    onToggleFilterDropdown={(payload) => this.onToggleFilterDropdown(payload)} onApplianceCategoryCheckboxSelect={(e) => this.onApplianceCategoryCheckboxSelect(e)}
                    onApplyingFilters={() => this.onApplyingFilters()} showMoreRecos={() => this.showMoreRecos()} translations={this.props.translations.data} appliancesList={this.props.appliancesList}
                    configs={this.props.configs.data} handleModal={(recoId) => this.handleModal(recoId)} configColors={this.configColors} insightBulbImag={insightBulbImage}
                    handleRecoLikeUnlike={(recoId, event) => this.handleRecoLikeUnlike(recoId, event)}/>

                {this.state.activeRecoId ?
                    <Dialog open={this.state.open} onClose={() => this.handleModal(null)} aria-labelledby="scroll-dialog-reco" maxWidth="lg">
                        <RecommendationDetailsModal onCloseClick={() => this.handleModal(null)} activeReco={this.state.activeRecoId} 
                        onRecoLike={(recoID, event) => this.handleRecoLikeUnlike(recoID, event)} onRecoUnlike={(recoID, event) => this.handleRecoLikeUnlike(recoID, event)}/>
                    </Dialog>
                : ''}
            </div>
                  {this.props.configs && this.props.configs.data && this.props.configs.data["DASHBOARD.RECOMMENDATIONS_PAGE.FOOTER.SHOW"] === "true" ?
                  (<FooterMain configs={this.props.configs} translations={this.props.translations} />)
                  : ''
                }
            </>
        );
    }
}

const  mapStateToProps =  state => ({
    recommendationsData: state.recommendationsData,
    userIdentityDetails: state.userIdentityDetails,
    configs: state.configs,
    userObject: state.userObject,
    translations: state.translationsData,
    appliancesList: state.appliances.appliancesList,
    queryParams: state.queryParams,
    recoDetailsData : state.recoDetailsData
});

const mapDispatchToProps = dispatch => {
    return{
        setDropdownValues: (appliancesList) => { dispatch(setDropdownValues(appliancesList))},
        fetchTop5Reco: (userId, locale) => { dispatch(fetchTop5Reco(userId, locale)) },
        fetchRecoPrograms: (userId, fuelType, locale) => { dispatch(fetchRecoPrograms(userId, fuelType, locale))},
        fetchTipsToSaveEnergy: (type, categoryId, appliances, locale, wholeHomeSelected) => { dispatch(fetchTipsToSaveEnergy(type, categoryId, appliances, locale, wholeHomeSelected)) },
        toggleFilterDropdown: (payload) => { dispatch(toggleFilterDropdown(payload))},
        toggleRecoDropdownCheckbox: (payload) => { dispatch(toggleRecoDropdownCheckbox(payload)) },
        showRecoLoader: () => dispatch(showRecoLoader()),
        showMoreRecos: () => dispatch(showMoreRecos()),
        onViewRecos: (userId, recoId) => dispatch(onViewRecos(userId, recoId)),
        onRecoLike: (obj, index) => dispatch(onRecoLike(obj, index)),
        onRecoUnlike: (userId, recoId, index) => dispatch(onRecoUnlike(userId, recoId, index)),
        onUnselectAllRecosDropdown: () => dispatch(onUnselectAllRecosDropdown()),
        queryRecoCardLoaded: () => dispatch(queryRecoCardLoaded()),
        setUpdatingLikes: (index) => dispatch(setUpdatingLikes(index)),
        setAllowedAppliances : (allowedAppList) => dispatch(setAllowedAppliances(allowedAppList))
    }
}

export default withLastLocation(connect(mapStateToProps,mapDispatchToProps)(RecommendationsPageMain));
